import 'hammerjs';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '~app-environment';

import { RootPageComponent } from '~/root/root.page';
import { getRootProviders } from '~/root/root.providers';

try {
	if (environment.production) {
		enableProdMode();
	}

	bootstrapApplication(RootPageComponent, {
		providers: getRootProviders(),
	});
} catch (error) {
	console.error(error);
}
